import register from '@kpsys/angularjs-register';
import {recordEditationManagerFactory} from './services/record-editation-manager.factory';
import {EditableFieldTypeDataService} from './services/editable-field-type.data-service';
import {RecordEditationDataService} from './services/record-editation.data-service';
import {BasicRecordEditationActionFactory} from './utils/basic-record-editation-factory';
import {FieldsDefinitionsDataService} from './field7-and-field8-editors/fields-definitions-data.service';
import {Field7EditorModalComponent} from './field7-and-field8-editors/field7-editor-modal/field7-editor-modal.component';
import {Field8EditorModalComponent} from './field7-and-field8-editors/field8-editor-modal/field8-editor-modal.component';
import {field7EditorServiceFactory} from './field7-and-field8-editors/field7-editor-modal/field7-editor-service.factory';
import {field8EditorServiceFactory} from './field7-and-field8-editors/field8-editor-modal/field8-editor-service.factory';
import {authorityField8EditorServiceFactory} from './field7-and-field8-editors/authority-field8-editor-modal/authority-field8-editor-service.factory';
import {AuthorityField8EditorModalComponent} from './field7-and-field8-editors/authority-field8-editor-modal/authority-field8-editor-modal.component';
import {recordEditationRoutes} from './kp-record-editation-page/record-editation.routes';

/**
 * @ngdoc module
 * @name portaro.features.record-editation
 * @module portaro.features.record-editation
 */
export default register('portaro.features.record-editation')
    .config(recordEditationRoutes)
    .service(RecordEditationDataService.serviceName, RecordEditationDataService)
    .service(EditableFieldTypeDataService.serviceName, EditableFieldTypeDataService)
    .factory(recordEditationManagerFactory.factoryName, recordEditationManagerFactory)
    .service(BasicRecordEditationActionFactory.serviceName, BasicRecordEditationActionFactory)
    .service(FieldsDefinitionsDataService.serviceName, FieldsDefinitionsDataService)
    .factory(field7EditorServiceFactory.factoryName, field7EditorServiceFactory)
    .factory(field8EditorServiceFactory.factoryName, field8EditorServiceFactory)
    .factory(authorityField8EditorServiceFactory.factoryName, authorityField8EditorServiceFactory)
    .component(Field7EditorModalComponent.componentName, Field7EditorModalComponent)
    .component(Field8EditorModalComponent.componentName, Field8EditorModalComponent)
    .component(AuthorityField8EditorModalComponent.componentName, AuthorityField8EditorModalComponent)
    .name();